module.exports = __webpack_public_path__ + "static/media/visa.ad943dde.svg";